<template>
  <div>
    <SlListView
      ref="listView"
      @gotoPage="gotoPage"
      :total="page.total"
      :pageIndex="page.pageIndex"
      :pageSize="page.pageSize"
      :pageSizes="pageSizes"
    >
      <div slot="search">
        <!-- 搜索区域search包含搜索和重置按钮 -->
        <SlSearchForm
          ref="searchForm"
          v-model="formQuery"
          :items="searchItems"
          :loading="loading"
          @reset="reset"
          @search="gotoPage(page.pageSize)"
        ></SlSearchForm>
      </div>
      <!-- tab切换 -->
      <SlSwitchNav
        align="right"
        :navs="switchNavs"
        :default-active="switchActiveIndex"
        @select="switchNav"
      >
        <template v-slot:left>
          <span class="pdl-2rem">
            <SlButton
              class="mr-8px"
              type="primary"
              boxShadow="primary"
              :loading="loading"
              :disabled="!canExcute"
              @click="openDeliverDialog"
            >发货</SlButton>
            <SlButton
              class="mr-8px"
              type="primary"
              boxShadow="primary"
              :loading="loading"
              :disabled="!canExcute"
              @click="openPriceAuditDialog"
            >成本复核</SlButton>
            <SlButton type="primary" boxShadow="primary" :loading="loading" @click="exportPdf">导出</SlButton>
          </span>
        </template>
        <template v-slot:custom="{tab}">{{tab.tabName}}({{tab.count}})</template>
      </SlSwitchNav>
      <!-- 表格区域包含分页 -->
      <SlCardTable
        ref="cardTable"
        :data="tableData"
        :columns="columns"
        childName="awaitShipmentItemVoList"
      >
        <template #header="{row}">
          <el-tag
            class="mr-8px align-center"
            effect="plain"
            style="width: 54px;"
            :class="{'purple-tag': row.orderProcessType === 1, 'success-tag': row.orderProcessType === 2}"
          >{{row.orderProcessTypeName}}</el-tag>
          <el-tag v-if="row.fastOrderFlag" class="mr-8px float-right" type="danger">快返单</el-tag>
          <el-tag v-if="row.needRfid" class="mr-8px float-right">RFID</el-tag>
          <ul v-if="columns.length > 0" class="default-header-content">
            <li class="mr-24px" v-for="propItem in columns" :key="propItem.prop">
              <span class="header-prop-label mr-8px">{{propItem.label}}:</span>
              <span class="header-prop-value">{{row[propItem.prop]}}</span>
            </li>
          </ul>
        </template>
        <template #body="{row:cardRow}">
          <SlTable
            ref="table"
            v-model="selectionsTree[cardRow.id]"
            align="left"
            :border="false"
            :tableData="cardRow['awaitShipmentItemVoList']"
            :columns="childColumns"
            :operate="true"
            :tooltip="false"
            :isEmbedTable="true"
            rowKey="id"
            :rowId="cardRow.id"
            @selectRow="handleSelection"
          >
            <template #currencyName>{{ isEmpty(cardRow.currencyName) ? '-' : cardRow.currencyName}}</template>
            <template #warehouseName="{ row }">
              <p>{{row.warehouseName}}</p>
              <p v-if="row.orderProcessType === 1">
                <el-button
                  type="text"
                  @click="showSupplierDetail(row)"
                >{{row.processPlantSupplierName}}</el-button>
              </p>
            </template>
            <template #fileName="{ row }">
              <el-tooltip v-if="hasContractFile(row)" placement="top" :content="getContractFileName(row)">
                <el-button
                  class="contract-file-link"
                  type="text"
                  @click="downloadContract(row)"
                >{{getContractFileName(row)}}</el-button>
              </el-tooltip>
              <span v-else class="contract-file-empty">未上传</span>
            </template>
            <template #operation="{ row }">
              <el-button class="operation-btn" type="text" @click="downloadErpContract(row)">下载合同</el-button>
              <el-button class="operation-btn" type="text" @click="openUploadContractDialog(row)">上传合同</el-button>
            </template>
          </SlTable>
        </template>
      </SlCardTable>
    </SlListView>
    <!-- 发货对话框 -->
    <DeliveryDialog ref="deliveryDialog" @submit="gotoPage(page.pageSize)"></DeliveryDialog>
    <SupplierDialog v-bind.sync="supplier" />
    <!-- 成本复核 -->
    <PriceReviewDialog ref="priceReview" @submit="priceReviewSubmit"></PriceReviewDialog>
    <!-- 上传合同 -->
    <ContractUploadDialog ref="contractUploadDialog" @submit="handleContractUploadSuccess"></ContractUploadDialog>
    <!-- 发货、成本复核按钮操作提示弹窗 -->
    <SlDialog title="提示" :visible.sync="btnMessageVisible">
      {{btnMessageTip}}
      <template v-slot:bottom>
        <el-button @click="btnMessageVisible = false">关闭</el-button>
      </template>
    </SlDialog>
  </div>
</template>

<script>
import UserApi from '@api/user'
import OemGoodsAPI from '@api/oemGoods'
import CommonUrl from '@api/url.js'
import PriceReviewDialog from './components/PriceReviewDialog'
import DeliveryDialog from './pendingDeliverOrderList/DeliveryDialog.vue'
import ContractUploadDialog from './pendingDeliverOrderList/ContractUploadDialog.vue'
import SupplierDialog from './pendingOrderList/SupplierDialog'
import { exportFileFromRemote, errorMessageTip, isEmpty } from '@/shared/util'

export default {
  name: 'PendingOrderList',
  components: {
    DeliveryDialog,
    ContractUploadDialog,
    SupplierDialog,
    PriceReviewDialog
  },
  data () {
    return {
      loading: false,
      btnMessageVisible: false,
      tableData: [],
      selectionsTree: {},
      switchNavs: [],
      switchActiveIndex: '0',
      extraQuery: {
        status: 1
      },
      formQuery: {},
      page: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      pageSizes: [10, 20, 50],
      searchItems: [
        {
          type: 'batch-input',
          label: '生产订单号',
          name: 'purchaseOrderNumber'
        },
        {
          type: 'batch-input',
          label: 'SKU编码',
          name: 'sku'
        },
        {
          type: 'batch-input',
          label: 'UPC编码',
          name: 'upcs'
        },
        {
          type: 'input',
          label: '商品名称',
          name: 'commodityName'
        },
        {
          type: 'date',
          label: '下单时间',
          name: 'orderTimes',
          data: {
            datetype: 'daterange',
            isBlock: true
          }
        },
        {
          type: 'single-select',
          label: '快返单',
          name: 'fastOrderFlag',
          data: {
            remoteUrl: CommonUrl.dictUrl,
            params: { dataCode: 'YES_NO' }
          }
        },
        {
          type: 'single-select',
          label: '订单类型',
          name: 'orderProcessType',
          data: {
            remoteUrl: CommonUrl.dictUrl,
            params: { dataCode: 'ORDER_PROCESS_TYPE' }
          }
        }
      ],
      columns: [
        {
          prop: 'purchaseOrderNumber',
          label: '生产订单号'
        },
        {
          prop: 'orderTime',
          label: '下单时间'
        },
        {
          prop: 'factoryConfirmedDate',
          label: '订单交期'
        }
      ],
      childColumns: [
        {
          prop: 'skuCode',
          label: 'SKU编码'
        },
        {
          prop: 'upc',
          label: 'UPC编码'
        },
        {
          prop: 'skuImage',
          label: '商品图片',
          isImg: true,
          data: {
            imgSize: '8rem'
          }
        },
        {
          prop: 'name',
          label: '商品名称'
        },
        {
          prop: 'attributesName',
          label: '销售属性'
        },
        {
          prop: 'orderTypeName',
          label: '首/返单类型'
        },
        {
          prop: 'basePlateSkuCode',
          label: '底版SKU'
        },
        {
          prop: 'printedPattern',
          label: '花型号'
        },
        {
          prop: 'currencyName',
          label: '币种'
        },
        {
          prop: 'realPrice',
          label: '单价'
        },
        {
          prop: 'requireQuantity',
          label: '订单数量'
        },
        {
          prop: 'deliveryQuantity',
          label: '实际发货数量'
        },
        {
          prop: 'warehouseName',
          label: '到货仓库'
        },
        {
          prop: 'fileName',
          label: '合同文件',
          width: '160px'
        }
      ],
      supplier: {
        data: {},
        visible: false
      },
      btnMessageTip: '',
      selectCount: 0

    }
  },
  computed: {
    canExcute () {
      return Object.values(this.selectionsTree).some(selections => selections.length)
    }
  },
  mounted () { },
  methods: {
    handleSelection (row, rowId) {
      this.tableData.forEach(v => {
        if (v.id === rowId) {
          v['isChecked'] = row.length > 0
        }
      })
      this.selectCount = this.tableData.filter(item => item.isChecked).length
    },
    gotoPage (pageSize = 10, pageIndex = 1) {
      const params = this.generateParams(pageSize, pageIndex)
      delete params.status // 列表接口不要这个参数
      this.loading = true
      OemGoodsAPI.getAwaitShipmentsList(params).then(res => {
        let { success, data = {} } = res
        if (success) {
          this.tableData = data.list || []
          this.page.total = data.total
          this.page.pageIndex = pageIndex
          this.page.pageSize = pageSize
          this.selectionsTree = {}
          this.getSwitchNavs()
          this.tableData.forEach(row => {
            this.formatChildRow(row)
            this.$set(this.selectionsTree, row.id, [])
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    reset () {
      this.switchActiveIndex = '0'
      this.gotoPage(this.page.pageSize)
    },
    getSwitchNavs () {
      OemGoodsAPI.getPendingDeliverStatic(this.getQureyParams()).then(res => {
        let { data = [] } = res
        this.switchNavs = data || []
      })
    },
    switchNav (index) {
      this.switchActiveIndex = index
      this.gotoPage(this.page.pageSize)
    },
    openDeliverDialog () {
      if (this.selectCount > 1) {
        this.$message.error('不允许多个订单合并发货')
        return
      }
      let { deliveryParams: params, deliveriedOrders, isWaitAuditPriceRecheckOrders } = this.prevDataHandler()
      if (this.btnHandleValidate('doDelivery', isWaitAuditPriceRecheckOrders, deliveriedOrders)) {
        this.$refs.deliveryDialog.openDialog({ params })
      }
    },
    generateParams (pageSize, pageIndex) {
      return {
        ...this.getQureyParams(),
        overdueDays: this.switchActiveIndex,
        pageIndex,
        pageSize
      }
    },
    getQureyParams () {
      let { orderTimes = [], ...orther } = this.formQuery
      return {
        ...orther,
        ...this.extraQuery,
        orderTimeStart: orderTimes && orderTimes[0] ? orderTimes[0] : '',
        orderTimeEnd: orderTimes && orderTimes[1] ? orderTimes[1] : ''
      }
    },
    showSupplierDetail (row) {
      const id = row.processPlantSupplierId
      UserApi.supplierShippingAddress(id).then(res => {
        if (res.success) {
          this.supplier = {
            data: res.data || {},
            visible: true
          }
        }
      })
    },
    formatChildRow (cardRow) {
      let childList = cardRow['awaitShipmentItemVoList']
      if (childList.length) {
        const { orderProcessType, processPlantSupplierName, purchaseOrderId, purchaseOrderNumber, contractUrl, fileName } = cardRow
        childList.forEach((item, index) => {
          childList[index] = {
            ...item,
            orderProcessType,
            processPlantSupplierName,
            purchaseOrderNumber,
            purchaseOrderId: item.purchaseOrderId || purchaseOrderId,
            contractUrl: item.contractUrl || contractUrl,
            fileName: item.fileName || fileName
          }
        })
      }
    },

    getErpContractFileName (row, contractUrl) {
      if (!contractUrl) {
        return ''
      }
      const contractUrlWithoutQuery = contractUrl.split('?')[0]
      const extensionMatch = contractUrlWithoutQuery.match(/\.([a-z0-9]+)$/i)
      const extension = extensionMatch ? extensionMatch[1] : 'pdf'
      return `${row.purchaseOrderNumber}采购合同.${extension}`
    },

    getContractFileName (row) {
      if (!row.contractUrl) {
        return ''
      }
      return row.fileName || ''
    },

    hasContractFile (row) {
      return !!(row && row.contractUrl && row.fileName)
    },

    downloadErpContract (row) {
      this.$store.dispatch('OPEN_LOADING', { isCount: false, loadingText: '下载中' })
      OemGoodsAPI.getErpContract(row.purchaseOrderId).then(res => {
        const { success, data: contractUrl } = res
        if (!success) {
          this.$store.dispatch('CLOSE_LOADING')
          return
        }
        if (!contractUrl) {
          this.$store.dispatch('CLOSE_LOADING')
          this.$message.error('暂无合同文件可下载')
          return
        }
        exportFileFromRemote({
          url: contractUrl,
          name: this.getErpContractFileName(row, contractUrl),
          afterLoad: () => this.$store.dispatch('CLOSE_LOADING'),
          errorFn: () => errorMessageTip('合同文件下载失败')
        })
      }).catch(() => {
        this.$store.dispatch('CLOSE_LOADING')
        errorMessageTip('合同文件下载失败')
      })
    },

    downloadContract (row) {
      const contractUrl = row.contractUrl
      if (!contractUrl) {
        this.$message.error('暂无合同文件可下载')
        return
      }

      exportFileFromRemote({
        url: contractUrl,
        name: this.getContractFileName(row),
        beforeLoad: () => this.$store.dispatch('OPEN_LOADING', { isCount: false, loadingText: '下载中' }),
        afterLoad: () => this.$store.dispatch('CLOSE_LOADING'),
        errorFn: () => errorMessageTip('合同文件下载失败')
      })
    },
    openUploadContractDialog (row) {
      this.$refs.contractUploadDialog.openDialog(row)
    },
    handleContractUploadSuccess () {
      this.gotoPage(this.page.pageSize, this.page.pageIndex)
    },
    openPriceAuditDialog () {
      let { deliveriedOrders, isWaitAuditPriceRecheckOrders, skuRows } = this.prevDataHandler()
      if (this.btnHandleValidate('doPriceReview', isWaitAuditPriceRecheckOrders, deliveriedOrders)) {
        this.$refs.priceReview.openDialog(skuRows)
      }
    },
    exportPdf () {
      this.loading = true
      const pageSize = this.page.pageSize
      const pageIndex = this.page.pageIndex
      const obj = this.generateParams(pageSize, pageIndex)
      const params = {
        ...obj
      }
      OemGoodsAPI.exptawaitshipmentslist(params).then(res => {
        if (res.success === false) return
        const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' })
        const csvURL = window.URL.createObjectURL(csvData)
        const tempLink = document.createElement('a')
        tempLink.href = csvURL
        tempLink.setAttribute('download', '待发货列表.csv')
        tempLink.click()
      }).finally(() => {
        this.loading = false
      })
    },
    // 操作按钮前的数据预处理
    prevDataHandler () {
      let deliveryParams = []
      let deliveriedOrders = []
      let isWaitAuditPriceRecheckOrders = []
      let skuRows = Object.keys(this.selectionsTree).reduce((acc, key) => {
        let curSelections = this.selectionsTree[key]

        if (curSelections.length > 0) {
          let row = this.tableData.find(item => String(item.id) === String(key))
          if (row) {
            // 存储已经发过货的订单号
            if (![0, 1].includes(row.status)) {
              deliveriedOrders.push(row.purchaseOrderNumber)
            }
            // 存储待处理成本复核的订单号
            if (row.isWaitAuditPriceRecheck) {
              isWaitAuditPriceRecheckOrders.push(row.purchaseOrderNumber)
            }
          }

          let arr = curSelections.map(item => {
            // 存储传入发货弹窗的数据
            deliveryParams.push({
              purchaseOrderId: item.purchaseOrderId,
              purchaseOrderItemId: item.id
            })

            return {
              purchaseOrderNumber: row.purchaseOrderNumber,
              id: item.id,
              skuCode: item.skuCode,
              skuImage: item.skuImage,
              name: item.name,
              attributesName: item.attributesName,
              originPrice: item.realPrice,
              currencyName: row.currencyName || ''
            }
          })
          acc = acc.concat(arr)
        }
        return acc
      }, [])
      return {
        deliveryParams,
        deliveriedOrders,
        isWaitAuditPriceRecheckOrders,
        skuRows
      }
    },
    // 操作按钮前的校验
    btnHandleValidate (type, isWaitAuditPriceRecheckOrders, deliveriedOrders) {
      let msg0 = `订单号：${isWaitAuditPriceRecheckOrders.join()} 存在待处理成本复核,不能操作 !`
      let msg1 = `订单号：${deliveriedOrders.join()} 已发货,不能申请成本复核 !`
      if (type === 'doDelivery') { // 发货
        return isWaitAuditPriceRecheckOrders.length ? !!this.showMessageTip(msg0) : true
      }

      if (type === 'doPriceReview') { // 成本复核
        return isWaitAuditPriceRecheckOrders.length ? !!this.showMessageTip(msg0) : deliveriedOrders.length ? !!this.showMessageTip(msg1) : true
      }
      return true
    },
    showMessageTip (msg) {
      this.btnMessageTip = msg
      this.btnMessageVisible = true
    },
    priceReviewSubmit () {
      this.gotoPage(this.page.pageSize)
    },
    isEmpty
  }
}
</script>

<style lang="scss" scoped>
.purple-tag {
  color: purple;
  border-color: purple;
}
.success-tag {
  border-color: #c2e7b0;
  color: #67c23a;
}
.contract-file-link {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.contract-file-empty {
  color: #c0c4cc;
}
.operation-btn {
  margin-left: 0 !important;
  margin-right: 0.8rem;
}
</style>
